<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    :esg-subscription="esgSubscription"
    :prices-assessment-subscription="subscription"
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
      :esg-subscription="esgSubscription"
      :prices-assessment-subscription="subscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  COBALT,
  MARKET,
  SUBSCRIPTION_ESG_COBALT,
  SUBSCRIPTION_FORECASTS_COBALT,
  SUBSCRIPTION_PRICE_ASSESSMENTS_COBALT,
} from '~/constants/services/constants'
import cobaltData from '~/constants/data-reports/cobalt'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(COBALT)
const productData = ref(cobaltData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_COBALT)
const esgSubscription = ref(SUBSCRIPTION_ESG_COBALT)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_COBALT)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${COBALT.name} Data and Reports`,
})
useHead(seo)
</script>
